import { Subscription } from "rxjs";

import { AppConstants } from "../../../../app.constants";
import { CustomFileModel } from "../../entities/file.type";
import { PlaylistInnerItemLinkModel } from "./playlist-inner-item-link.model";

export class PlaylistItemLinkModel {
  Id: number;
  Duration: string;
  File: CustomFileModel;
  FileId: string;
  IsFile: boolean;
  PlaylistItemId: number;
  ZoomLevel: number;
  RefreshInterval: string;
  InnerItemLinks: PlaylistInnerItemLinkModel[];
  InnerItemDuration: string;
  PdfStartPage: number;

  duration: string;
  percentage: number;
  icon: string;
  content: string | ArrayBuffer;
  videoContent: string | ArrayBuffer;
  isConverting: boolean;
  convertingRequest: Subscription;

  constructor(public Link: string = '') {
    this.ZoomLevel = AppConstants.DEFAULT_PLAYLIST_ZOOM_LEVEL;
    this.InnerItemLinks = [];
    this.InnerItemDuration = AppConstants.DEFAULT_INNER_ITEM_DURATION;
  }
}
